export const TypographyHeight = {
  H1: '32px',
  H2: '28px',
  H3: '24px',
  H4: '20px',
  H5: '20px',
  H6: '18px',
  P1: '32px',
  P2: '24px',
  P3: '20px',
  P4: '20px',
  P5: '18px',
  DISPLAY: '80px'
};
